// import React, { useState, useEffect } from 'react';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Paper, CircularProgress } from '@mui/material';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const OrdersListPage = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();  // Updated to useNavigate

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       const { data } = await axios.get('/Orders/Open');
//       setOrders(data);
//     } catch (error) {
//       console.error(error);
//     }
//     setLoading(false);
//   };

//   const openOrder = (id) => {
//     navigate(`/orders/${id}`);  // Updated to use navigate
//   };

//   if (loading) return <CircularProgress />;

//   return (
//     <div>
//       Reserved for Sikhu
//       <h2>Orders List</h2>
//       <Button variant="contained" color="primary" onClick={() => navigate('/orders/new')}>
//         New Order
//       </Button>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Server ID</TableCell>
//               <TableCell>Operator Name</TableCell>
//               <TableCell>Brand Name</TableCell>
//               <TableCell>Environment</TableCell>
//               <TableCell>Site</TableCell>
//               <TableCell>Market</TableCell>
//               <TableCell>Status</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {orders.map((order) => (
//               <TableRow key={order.id}>
//                 <TableCell>{order.serverId}</TableCell>
//                 <TableCell>{order.operatorName}</TableCell>
//                 <TableCell>{order.brandName}</TableCell>
//                 <TableCell>{order.environment}</TableCell>
//                 <TableCell>{order.siteCode}</TableCell>
//                 <TableCell>{order.marketCode}</TableCell>
//                 <TableCell>{order.statusId === 1 ? 'Incomplete' : 'Validated'}</TableCell>
//                 <TableCell>
//                   <Button variant="outlined" onClick={() => openOrder(order.id)}>
//                     Edit
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </div>
//   );
// };

// export default OrdersListPage;

import React, { useState } from 'react';
import {
  Tabs,
  Tab,
  Box,
  Paper,
  Typography
} from '@mui/material';

const OrdersFormPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Custom Tab Panel component
  const TabPanel = ({ children, value, index }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      style={{ height: 'calc(100vh - 180px)' }} // Adjust height as needed
    >
      {value === index && children}
    </div>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={0}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            backgroundColor: 'var(--background-secondary)',
          }}
        >
          <Tab label="Monday Board" />
          <Tab label="Jira" />
          <Tab label="Placeholder" />
        </Tabs>
      </Paper>

      <TabPanel value={activeTab} index={0}>
        <Typography variant="h6" sx={{ p: 2 }}>
          Monday Integration Coming Soon
        </Typography>
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <Typography variant="h6" sx={{ p: 2 }}>
          Jira Integration Coming Soon
        </Typography>
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <Typography variant="h6" sx={{ p: 2 }}>
          Placeholder Tab Content
        </Typography>
      </TabPanel>
    </Box>
  );
};

export default OrdersFormPage;